import { Card, CardContent, Typography } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { obtenerComprasDetalle } from "./../../../../ducks/viajeCalendarioDuck"
import { useParams } from "react-router-dom"
import {formatDinero} from "./../../../../utils/formatDinero"
const useStyles = makeStyles({
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    root: {
        minWidth: 380,
        maxWidth: 380,
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 30,
    },
});


const Cabecera = () => {
    const classes = useStyles();
    const { referencia } = useParams()
    const dispatch = useDispatch()
    const { cliente, comprasDetalle } = useSelector(store => store.calendario)
    
    useEffect(() => {
        dispatch(obtenerComprasDetalle({idPaquete: cliente?.paquete?.Id_Paquete, referencia}))
    },[dispatch, cliente?.paquete?.Id_Paquete, referencia])

    return (
        <div className={classes.container}>
            <Card className={classes.root}>
                <CardContent>
                    <Typography className={classes.pos} variant="h5" component="h2">
                        Proveedor
                    </Typography>
                    <Typography color="textSecondary" gutterBottom>
                        Precio Neto: {formatDinero(comprasDetalle.precioNeto)}
                    </Typography>
                    <Typography color="textSecondary">
                        Total pagado: {formatDinero(comprasDetalle.totalPagado)}
                    </Typography>
                </CardContent>
            </Card>
            <Card className={classes.root}>
                <CardContent>
                    <Typography className={classes.pos} variant="h5" component="h2">
                        Cliente
                    </Typography>
                    <Typography color="textSecondary" gutterBottom>
                        Monto Ahorrado: {formatDinero(comprasDetalle.montoAhorrado)}
                    </Typography>
                    <Typography color="textSecondary">
                        Saldo disponible: {formatDinero(comprasDetalle.saldoDisponible)}
                    </Typography>
                </CardContent>
            </Card>
            <Card className={classes.root}>
                <CardContent>
                    <Typography className={classes.pos} variant="h5" component="h2">
                        Utilidad
                    </Typography>
                    <Typography color="textSecondary" gutterBottom>
                        Prevista: {formatDinero(comprasDetalle.utilidadPrevista)}
                    </Typography>
                    <Typography color="textSecondary">
                        Real: {formatDinero(comprasDetalle.utilidadTotal)}
                    </Typography>
                </CardContent>
            </Card>
        </div>
    )
}
export default Cabecera